import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';
import './MobileSnapshots.less';
import React from 'react';

export default function MobileSnapshotSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <div className="description-content">
                    <MobileSnapshotResult snapshotUrl={result.snapshot_url} />

                    {hasCompetitors &&
                        Object.keys(competitorsResults).map((competitor) => (
                            <MobileSnapshotResult
                                key={competitor}
                                snapshotUrl={competitorsResults[competitor].snapshot_url}
                            />
                        ))}
                </div>
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type MobileSnapshotResultProps = {
    snapshotUrl: string;
};

function MobileSnapshotResult({ snapshotUrl }: MobileSnapshotResultProps) {
    return (
        <>
            {snapshotUrl && (
                <div
                    className="mobile-snapshots"
                    key="mobile-snapshots"
                >
                    <div className="mobile-view">
                        <div className="image-container">
                            <img
                                src={snapshotUrl}
                                alt="Mobile view"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
